export default __webpack_public_path__ + "static/media/Newsletter 022.39a01b82.png";